import getAllowedOptionsOperation from 'owa-service/lib/operation/getAllowedOptionsOperation';
import GetAllowedOptionsResponse from 'owa-service/lib/contract/GetAllowedOptionsResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function getAllowedOptions(): Promise<GetAllowedOptionsResponse> {
    return getAllowedOptionsOperation({
        Header: getJsonRequestHeader(),
    });
}
